import { useMemo } from "react";
import { Gesture } from "react-native-gesture-handler";
import { SharedValue, useSharedValue } from "react-native-reanimated";
import {
	calculateCropFromScaleWorklet,
	calculateCropFromTranslationWorklet,
} from "../helpers/calculateCropWorklets";

const useImageCropperGesture = ({
	cropSV,
	inside,
}: {
	cropSV: SharedValue<{ x: number; y: number; scale: number }>;
	inside: {
		width: number;
		height: number;
	};
}) => {
	// Two separate SVs so that one gesture doesn't overwrite the other gesture's start position
	const startCropTranslateSV = useSharedValue<{ x: number; y: number } | null>(null);
	const startCropScaleSV = useSharedValue<{
		scale: number;
	} | null>(null);
	const gesture = useMemo(() => {
		const panGesture = Gesture.Pan()
			.onStart(() => {
				"worklet";
				const crop = cropSV.value;
				startCropTranslateSV.value = {
					x: crop.x,
					y: crop.y,
				};
			})
			.onChange((event) => {
				"worklet";
				const start = startCropTranslateSV.value;
				const crop = cropSV.value;
				if (!start) return;
				cropSV.value = calculateCropFromTranslationWorklet({
					targetX: start.x + event.translationX / crop.scale,
					targetY: start.y + event.translationY / crop.scale,
					crop,
					inside,
				});
			});
		const pinchGesture = Gesture.Pinch()
			.onStart((event) => {
				"worklet";
				const crop = cropSV.value;
				startCropScaleSV.value = {
					scale: crop.scale,
				};
			})
			.onChange((event) => {
				"worklet";
				const start = startCropScaleSV.value;
				const crop = cropSV.value;
				if (!start) return;
				cropSV.value = calculateCropFromScaleWorklet({
					targetScale: start.scale * event.scale,
					crop,
					inside,
				});
			});
		return Gesture.Simultaneous(panGesture, pinchGesture);
	}, [cropSV, startCropTranslateSV, inside, startCropScaleSV]);
	return {
		gesture,
	};
};
export default useImageCropperGesture;
